import React from "react";

const DashboardFooter = () => {
  const currentYear = new Date().getFullYear();

  return (
    <div className="projectFooter">
      <p>© {currentYear} Grouped.</p>
    </div>
  );
};

export default DashboardFooter;
